import React from 'react';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Paper, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    height: '100vh',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.error.main,
  },
}));

function AccessDenied(props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <WarningRoundedIcon />
        <Typography component="h1" variant="subtitle1">
          دسترسی غیر مجاز!
        </Typography>
      </Paper>
    </div>
  );
}

export default AccessDenied;
